const BANK_NAME_MAPPING: Record<string, string> = {
	BAY: 'ธนาคารกรุงศรี',
	BBL: 'ธนาคารกรุงเทพ',
	KBANK: 'ธนาคารกสิกรไทย',
	KTB: 'ธนาคารกรุงไทย',
	SCB: 'ธนาคารไทยพาณิชย์',
	CIMB: 'ธนาคารซีไอเอ็มบี',
	UOB: 'ธนาคารยูโอบี',
	GSB: 'ธนาคารออมสิน',
	GHB: 'ธนาคารอาคารสงเคราะห์',
	BAAC: 'ธนาคารธ.ก.ส.',
	TISCO: 'ธนาคารทิสโก้',
	KKP: 'ธนาคารเกียรตินาคินภัทร',
	TCRB: 'ธนาคารไทยเครดิต',
	LHBANK: 'ธนาคารแลนด์ แอนด์ เฮ้าส์',
}

/**
 * Maps a bank code to its Thai name.
 * Returns "CODE (ชื่อภาษาไทย)" if a mapping exists, otherwise returns the code as-is.
 */
export const formatBankName = (bankCode: string | null | undefined): string => {
	if (!bankCode) return '-'
	const thaiName = BANK_NAME_MAPPING[bankCode.toUpperCase()]
	return thaiName ? `${bankCode} (${thaiName})` : bankCode
}

/**
 * Returns only the Thai name, falling back to the code if unmapped.
 */
export const getBankThaiName = (
	bankCode: string | null | undefined,
): string => {
	if (!bankCode) return '-'
	return BANK_NAME_MAPPING[bankCode.toUpperCase()] ?? bankCode
}
